export const wspTypeData = [
     {
    label: "NAKURU",
    value: "NAKURU",
  },
  {
    label: "NYERI",
    value: "NYERI",
  }, 
];
export const rolesData = [
     {
    label: "Admin",
    value: "ADMIN",
  },
  {
    label: "User",
    value: "USER",
  }, 
];